import { render, staticRenderFns } from "./ReportGroupings.vue?vue&type=template&id=1680bc0d&scoped=true"
import script from "./ReportGroupings.vue?vue&type=script&lang=js"
export * from "./ReportGroupings.vue?vue&type=script&lang=js"
import style0 from "./ReportGroupings.vue?vue&type=style&index=0&id=1680bc0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1680bc0d",
  null
  
)

export default component.exports